import React, { useEffect } from "react";
import EventHeader from "./EventHeader";
import { useNavigate, useParams } from "react-router-dom";
import { getEventByIdActionFetchData } from "../../../redux/actions/getEventByIdAction";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { submitEventFormAction } from "../../../redux/actions/submitEventFormAction";
import { submiteventform_FETCH_DATA_SUCCESS } from "../../../redux/actionType";
import { eventbaseurlforimages } from "../../../utils/httpService";
// import './../../assets/events.css'
const EventDetails = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();
  // const baseurlforimages = "https://api-sandesh-competition.nichetechqa.com";
  const baseurlforimages = eventbaseurlforimages

  
  useEffect(() => {
    dispatch(getEventByIdActionFetchData(id));
  }, [dispatch]);
  
  const eventData = useSelector((state) => state.getEventByIdReducer.data);

  // useEffect(() => {
  //   if (eventData && eventData.event) {
  //     console.log("eventData", eventData.event);
  //   }
  // }, [eventData]);

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <>
      <EventHeader />
      <div className="event-container">
        <div className="container py-5">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h2 className="fw-bold mb-4">Event Details</h2>
            <div className="breadcrumb" style={{backgroundColor: 'white'}}>
              <li className="breadcrumb-item">
                <a onClick={() => navigate("/event")}>Home</a>
              </li>
              <li className="breadcrumb-item">
                <a onClick={() => navigate("/all-events")}>All Events</a>
              </li>
              <li className="breadcrumb-item active">Event Details</li>
            </div>
          </div>
          {eventData && eventData.event && (
            <div className="row align-items-center g-4">
              <div className="col-md-6">
                <img
                  src={eventData.event.media && eventData.event.media[0] 
                    ? `${baseurlforimages}${eventData.event.media[0].url}`
                    : ""}
                  className="img-fluid rounded shadow-sm"
                  alt="Event Image"
                />
              </div>
              <div className="col-md-6 event-info" style={{fontSize: '1.2rem'}}>
                <h2 className="fw-bold">{eventData?.event?.title}</h2>
                <p>
                <i className="fas fa-calendar-alt" ></i>    <strong> 
                  Event Date:</strong> {eventData?.event?.eventDate?.startDate === eventData?.event?.eventDate?.endDate
                    ? formatDate(eventData?.event?.eventDate?.startDate)
                    : `${formatDate(eventData?.event?.eventDate?.startDate)} - ${formatDate(eventData?.event?.eventDate?.endDate)}`}
                </p>
                <p>
               <i className="fas fa-clock"> </i>
                <strong> Event Time:  </strong>  {eventData?.event?.eventDate?.startTime} - {eventData?.event?.eventDate?.endTime}
                </p>
                <p>
                <i className="fas fa-calendar-alt" ></i>  <strong> Registration  Date:</strong> {formatDate(eventData?.event?.registerationdate?.startDate)} - {formatDate(eventData?.event?.registerationdate?.endDate)}
                </p>
                <p>
                <i className="fas fa-map-marker-alt"></i>
                <strong> Location:</strong> {eventData?.event?.venue}, {eventData?.event?.city}, {eventData?.event?.state}
                </p>
                <p>
                <i className="fas fa-rupee-sign"></i>
  <strong> Price:</strong> ₹{eventData?.event?.fees} per person
                </p>
             {eventData?.event?.email && <p><i className="fas fa-envelope"></i>
              <strong> Email :</strong> {eventData?.event?.email}</p>}
            { eventData?.event?.contactInformation && <p><i className="fas fa-phone-alt"></i>
              <strong> Phone :</strong> {eventData?.event?.contactInformation}</p>}
                <a
                  onClick={() => {
                    const status = eventData?.event?.status;
                    if (status === "Active") {
                      navigate(`/event-booking/${eventData?.event?._id}`);
                    } else if (status === "Upcoming") {
                         Swal.fire(
                          "Registration Not Open", "This event is upcoming. Registration will open soon.", "info", {allowOutsideClick: false})
                    } else if (status === "Closed") {
                      Swal.fire("Registration Closed", "Registration for this event is closed.", "error", {allowOutsideClick: false})
                    }
                  }}
                  className="btn btn-primary mt-3 px-4"
                >
                  Register Now  
                </a>
              </div>
            </div>
          )}
          {/* About Section */}
          {eventData && eventData.event && (
            <div className="row mt-5">
              <div className="col-10">
                <h4 className="fw-semibold mb-3">About This Event</h4>
                <p className="text-muted" dangerouslySetInnerHTML={{__html: eventData?.event?.description}}>
                 
                </p>
                <h4 className="fw-semibold mb-3">{eventData?.event?.updates[0]?.title}</h4>
               
                <p dangerouslySetInnerHTML={{__html: eventData?.event?.updates[0]?.description}}></p>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default EventDetails;
